/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2PlusFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2PlusFilled({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2PlusFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2PlusFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-Z1sELMW': alignSelf,'--mt-2-Z1sELMW': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1sELMW': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1sELMW': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1sELMW': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1sELMW': opacity,'--w-10-Z1sELMW': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1sELMW': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1sELMW': fill,'--a-7-Z1sELMW': isAnimated ? animation : "none",'--sd-8-Z1sELMW': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1sELMW': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2PlusFilled.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M12 6A6 6 0 110 6a6 6 0 0112 0zM6 2.786c.355 0 .643.288.643.643v1.928H8.57a.643.643 0 010 1.286H6.643V8.57a.643.643 0 01-1.286 0V6.643H3.43a.643.643 0 010-1.286h1.928V3.43c0-.355.288-.643.643-.643z"
 style={{'--f-12-Z1sELMW': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}